
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const DeleteAccount = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ACCOUNT_DELETE_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'ACCOUNT_DELETE_ERROR':
            return { loading: false, error: true, data: [] };
        case 'ACCOUNT_DELETE_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'ACCOUNT_DELETE_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default DeleteAccount